<div class="summary-group" [ngClass]="{ 'alignment-block': alignment === 'block' }" [class]="divider">
  <div class="mb-3">
    <h6 uni-heading *ngIf="heading">{{ heading }}</h6>
    <ng-content select="[summary-group-heading]"></ng-content>
  </div>

  <ng-content></ng-content>
  <ng-content select="uni-summary-section"></ng-content>
</div>
